module.exports = __webpack_public_path__ + "static/media/logo.cc236c6f.png";